module.exports = "/packs/she-creators-schedule-image-2940721c66fe49a7a168564fbcd88f7a.png";